import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TimeZoneService } from '@core/services/time-zone.service';

export const timeZoneResolver: ResolveFn<void> = () => {
  return inject(TimeZoneService).setTimeZones();
};
